/* global BigInt */

import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import ICellProps from '../ICellProps';


interface IProps extends ICellProps {
  onChange: (value: string | number | null) => void;
  field: any;
  dataAttr: { [key: string]: string | number | boolean};
};


const TextInput = styled.input`
  position: absolute;
  display: block;
  top:0;
  left:0;
  margin: 0;
  height: 100%;
  width: 100%;
  border: none;
  padding: 0;
  box-sizing: border-box;
  outline: none;
  padding: 0 10px;
`;

const Number: React.FC<IProps> = ({
  value,
  field: { maxValue, minValue, maxLengthValue, type, required, canBeNegative },
  onChange,
  dataAttr
}) => {
  const [localValue, setLocalValue] = useState<any>(value);

  const onChangeHandler = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    let eventVal = event.target.value;
    if (canBeNegative) {
      if (eventVal.startsWith('-')) {
        eventVal = '-' + eventVal.slice(1).replace(/\D/g, '');
      } else {
        eventVal = eventVal.replace(/\D/g, '');
      }
    } else {
      eventVal = eventVal.replace(/\D/g, '');
    }
    
    if (maxLengthValue && eventVal.length > maxLengthValue) return;
    if (minValue && required && (type === 'number' ? +eventVal : BigInt(eventVal)) < (type === 'number' ? minValue : BigInt(minValue))) eventVal = minValue;
    if (maxValue && (type === 'number' ? +eventVal : BigInt(eventVal)) > (type === 'number' ? maxValue : BigInt(maxValue))) eventVal = maxValue;
    event.target.value = eventVal;
    setLocalValue(eventVal)
    onChange && eventVal !== '-' && onChange(type === 'number' ? eventVal < minValue && !required ? null : +eventVal : eventVal);
  }, [onChange, maxLengthValue, maxValue, minValue]);

  return <TextInput value={localValue ?? ''} onChange={onChangeHandler} {...dataAttr} />;
}

export default Number;